enum InputMode {
  PRIMARY = 'Primary',
  DISABLED = 'Disabled',
  SUCCESS = 'Success',
  DANGER = 'Danger',
  ADMIN = 'Admin'
}
export default InputMode;
